export default __webpack_public_path__ + "static/AlphaQ-65a53a00e58f9555a9ef88eb0b55a6b9.pdf";